import React, { useEffect, useState } from "react";
import { Button, Dropdown, Flag, FlagNameValues, Menu } from "semantic-ui-react";
import agent from "../../api/agent";
import { useStore } from "../../stores/store";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LanguageDto } from "../../models/languageDto";

export default function LanguageSwitcher() {
  const { commonStore } = useStore();
  const { i18n } = useTranslation("common");
  const [loading, setLoading] = useState<boolean>(true);
  const [languages, setLanguages] = useState<LanguageDto[]>();

  const changeLanguage = (language: string) => {
    if (commonStore.currentSurveyCode == null) {
      commonStore.setLanguage(language);
      i18n.changeLanguage(language);
    } else {
      setLoading(true);
      agent.Translations.getSurveyContent(commonStore.currentSurveyCode, language)
        .then((result) => {
          commonStore.setSurveyConentTranslations(result);
          commonStore.setLanguage(language);
          i18n.changeLanguage(language);
        })
        .catch(() => {
          toast.error("Failed to load selected language");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    setLoading(true);
    agent.Surveys.languages(commonStore.currentSurveyId)
      .then((result) => {
        setLanguages(result);
      })
      .catch(() => {
        toast.error("Failed to load languages");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [commonStore.currentSurveyId]);

  const [currentLanguageFlag, setCurrentLanguageFlag] = useState<FlagNameValues>("uk");
  useEffect(() => {
    if (!commonStore.lang) setCurrentLanguageFlag("uk");
    else if (commonStore.lang === "en") setCurrentLanguageFlag("uk");
    else setCurrentLanguageFlag(commonStore.lang as FlagNameValues);
  }, [commonStore.lang]);

  const content = (
    <Dropdown
      button
      className="icon langflag-dd"
      floating
      labeled
      icon={<Flag className="langflag" name={currentLanguageFlag} />}
      text="Language"
      loading={loading}
    >
      <Dropdown.Menu className="lang-dd">
        {languages &&
          languages.length > 0 &&
          languages.map((language) => (
            <Dropdown.Item key={language.id}>
              <Button onClick={() => changeLanguage(language.locale)} loading={loading}>
                <Flag name={language.flagName as FlagNameValues} /> {language.name}
              </Button>
            </Dropdown.Item>
          ))}
      </Dropdown.Menu>
    </Dropdown>
  );

  return <>{content}</>;
}
